export const APP_VERSION = 'v0.0.3 (1)'